<template>
  <div class="header">
    <div class="header-bg"></div>
    <div class="header__content">
      <div class="header__text">
        <h1 class="headline">Who we are?</h1>
        <p class="desc">
          Expert Designers and Developers trained in the creative
          and digital industry who offer a bespoke,
          professional and trustworthy service.
        </p>
        <ButtonCTA to="/contact" color="white" class="gt-sm">
          Hire us
        </ButtonCTA>
      </div>
      <div class="header__contact gt-xs">
        <div class="contact-section">
          <p>3 Ashley Road</p>
          <p>Bournemouth, England, BH1 4LE</p>
        </div>
        <div class="contact-section">
          <a class="line-link" href="mailto:contact@feat.software">contact@feat.software</a>
        </div>
      </div>
    </div>
    <div class="header-img"
         :style="
          {
            backgroundImage: `url(
              ${require(`@/assets/home_header_${viewport.higherViewportName}.png`)}
            )`
          }
         ">
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
  name: 'Header',
  computed: {
    ...mapState('viewport', ['viewport']),
  },
};
</script>

<style scoped lang="stylus">
  @import '../../styles/variables';
  .header{
    position: relative;
    z-index: 610;
  }
  .header-bg{
    position: absolute;
    bottom: 25px;
    left: 75px;
    background-image: url('../../assets/about_bg_sign.png');
    width: 547px;
    height: 608px;
    background-size:  cover;
    z-index: -1;
  }
  .header__content{
    padding: 0 40px;
    padding-top: 135px;
  }
  .header__text{
    max-width: 450px;
  }
  .headline{
    font-family: 'Dosis', sans-serif;
    font-size: 38px;
    line-height: 47px;
    font-weight: 200;
    margin-bottom: 35px;
  }
  .desc{
    font-size: 18px;
    line-height: 32px;
    margin-bottom: 45px;
  }
  .header-img{
    height: 290px;
    width:100%;
    background-size: cover;
    background-position-y: 50%;
    background-position-x: center;
  }

  @media(min-width: $breakpoint-sm-min){
    .header-img{
      background-position-x: 85%;
      transform: scaleX(-1);
    }

    .header__content{
      padding-top: 210px;
      padding-bottom: 70px;
      padding-left: 0;
      padding-right: 0;
      max-width: 450px;
      margin: 0 auto;
    }
    .desc{
      margin-bottom: 0;
    }
    .header__text{
      margin-bottom: 180px;
    }
    .header__contact{
      display: flex;
      justify-content: flex-end;

      a{
        display: block;
      }
      p,a{
        font-size: 14px;
        line-height: 26px;
        color: #7C7C7C;
        font-weight: 300;
      }
    }
    .contact-section{
      text-align: right;

      &:first-child{
        padding-right: 40px;
      }
    }
    .headline{
      font-size: 60px;
      line-height: 67px;
    }
    .desc{
      font-size: 20px;
      line-height: 36px;
    }
    .header__text{
      max-width: none;
    }
    .header-img{
      height: 722px;
    }
    .header-bg{
      height: 1230px;
      width: 1107px;
      bottom: 550px;
      left: 0;
    }
  }

  @media(min-width: $breakpoint-md-min){
    .header-img{
      height: 480px;
    }
    .header__content{
      display : flex;
      max-width: 960px;
      justify-content: space-between;
    }
    .header__text{
      max-width: 420px;
      margin-bottom: 0;
    }
    .header__contact{
      display: flex;
      flex-direction: column;
      justify-content: flex-start;
    }
    .contact-section{
      &:first-child{
        padding-right: 0;
        padding-bottom: 35px;
        padding-top: 35px;
      }
    }
    .desc{
      margin-bottom: 50px;
    }
    .header-bg{
      width: 819px;
      height: 910px;
      top: -18px;
      bottom: auto;
      left: 680px;
      right: auto;
    }
  }

  @media(min-width: $breakpoint-lg-min) {
    .header__content{
      padding-top: 250px;
      padding-bottom: 115px;
      max-width: 1370px;
    }
    .header__text{
      max-width: 480px;
    }
    .headline{
      font-size: 80px;
      line-height: 91px;
    }
    .desc{
      font-size: 22px;
      line-height: 36px;
    }
    .header-bg{
      width: 1107px;
      height: 1230px;
      top: -338px;
      bottom: auto;
      left: 890px;
      right: auto;
    }
  }
</style>
